import { Component, Prop, Vue, Watch, Emit } from "vue-property-decorator";
import anime from "animejs";

@Component
export default class BackgroundCurtainsAnimation extends Vue {
  $refs!: {
    root: HTMLElement;
  };
  /**
   *  Считает ширину для шторки с указанный номером
   * @returns {number} Ширина в пикселях
   * @param {number} index  Номер шторки
   * */
  calcWidthForSection(index: number): number {
    let widthForFirstAndLast = 220;
    if (this.$browser.width < 1200) widthForFirstAndLast = 80;
    if (this.$browser.width < 1020) widthForFirstAndLast = 35;
    if (this.$browser.width < 400) widthForFirstAndLast = window.innerWidth;

    let width =
      (this.$browser.width - widthForFirstAndLast * 2) /
      (this.numberOfCurtains - 2);
    if (index == 1 || index == this.numberOfCurtains) {
      return widthForFirstAndLast;
    }
    return Math.ceil(width) + 1;
  }

  /**
   * Определяет позицию шторки по ее номеру
   * @returns {number} Отступ слева в пикселях
   * @param {number} index  Номер шторки
   * */
  calcLeftForSection(index: number): number {
    let left = 0;
    for (let q = 1; q < index; q++) {
      left += (this.calcWidthForSection(q) - 1);
    }
    return left;
  }

  /*
   * Количество шторок к отображению
   */
  get numberOfCurtains(): number {
    if (this.$browser.width > 900) return 5;
    else if (this.$browser.width > 400) return 4;
    else return 1;
  }

  curtainsLeaveAnimation() {
    let elements = this.$refs.root.querySelectorAll(".apply-mask");
    let curtains = this.$refs.root.querySelectorAll(".curtain-mask-element");

    elements.forEach(element => {
      element.setAttribute('mask', `url(#bg_mask_${(this as any)._uid})`);
    });

    for (let index = 0; index < curtains.length; index++) {
      (index => {
        const curtain = curtains[index];
        anime({
          targets: curtain,
          duration: 700,
          translateZ: 0,
          translateX: [
            this.calcLeftForSection(index + 1),
            this.calcLeftForSection(index + 1) +
              this.calcWidthForSection(index + 1)
          ],
          width: [this.calcWidthForSection(index + 1), 0],
          easing: "easeOutQuad",
          delay: () => {
            return 160 * index;
          }
        });
      })(index);
    }

    setTimeout(() => {
      elements.forEach(element => {
        element.setAttribute('mask', ``);
      });
    }, 2000);
  }

  curtainsEnterAnimation() {
    let curtains = this.$refs.root.querySelectorAll(".curtain-mask-element");
    let elements = this.$refs.root.querySelectorAll(".apply-mask");
    
    elements.forEach(element => {  
      element.setAttribute('mask', `url(#bg_mask_${(this as any)._uid})`);
    });

    for (let index = 0; index < curtains.length; index++) {
      (index => {
        const curtain = curtains[index];
        (anime as any).set(curtain, {translateX: this.calcLeftForSection(index + 1)});
        anime({
          targets: curtain,
          duration: 700,
          translateZ: 0,
          width: [0, this.calcWidthForSection(index + 1)],
          easing: "easeOutQuad",
          delay: () => {
            return 160 * index;
          }
        });
      })(index);
    }

    setTimeout(() => {
      elements.forEach(element => {
        element.setAttribute('mask', ``);
      });
    }, 2000);
  }

  setWidthToCurtains() {
    this.$nextTick(() => {
      let curtains = this.$refs.root.querySelectorAll(".curtain-mask-element");
      for (let index = 0; index < curtains.length; index++) {
        const curtain = curtains[index];
        (anime as any).set(curtain, {translateX: this.calcLeftForSection(index + 1)});
        curtain.setAttribute(
          "width",
          this.calcWidthForSection(index + 1).toString()
        );
      }
    });
  }
}
